import { mapValues } from 'lodash';
import { darken, lighten, mix, saturate } from 'polished';

// Colours
export const COLOURS = {
    violet: 'hsl(275, 46%, 80%)',
    blue: 'hsl(202, 38%, 86%)',
    beige: 'hsl(22, 30%, 93%)',
    grey: 'hsl(272, 12%, 75%)',
    green: 'hsl(98, 52%, 72%)',
    red: 'hsl(341, 67%, 60%)',
    yellow: 'hsl(48, 88%, 60%)',
    pink: 'hsl(350, 83%, 88%)',
};

export const BORDER_COLOUR = 'hsl(0, 0%, 90%)';
export const BORDER_COLOUR_HOVER = darken(0.2, BORDER_COLOUR);
export const BORDER_COLOUR_FOCUS = darken(0.6, BORDER_COLOUR);

// export const BORDERS = {
//     violet: `2px solid ${COLOURS.violet}`,
//     blue: `2px solid ${COLOURS.blue}`,
//     beige: `2px solid ${COLOURS.beige}`,
//     grey: `2px solid ${COLOURS.grey}`,
//     green: `2px solid ${COLOURS.green}`,
//     red: `2px solid ${COLOURS.red}`,
//     yellow: `2px solid ${COLOURS.yellow}`,
//     pink: `2px solid ${COLOURS.pink}`,
// };

export const WHITE = 'hsl(0, 0%, 99%)';

export const BACKGROUND_COLOUR = 'hsl(268, 20%, 98%)';

export const COLOURS_EXTRA_LIGHT = mapValues(COLOURS, colour => lighten(0.16, colour));
export const COLOURS_LIGHT = mapValues(COLOURS, colour => lighten(0.05, colour));
export const COLOURS_DARK = mapValues(COLOURS, colour => darken(0.07, colour));
export const COLOURS_EXTRA_DARK = mapValues(COLOURS, colour => darken(0.2, colour));

export const COLOURS_FADED = mapValues(COLOURS, colour => saturate(0.1, mix(0.07, colour, '#ffffff')));
export const COLOURS_FADED_TEXT = mapValues(COLOURS, colour => saturate(0.1, mix(0.02, colour, '#ffffff')));

export const TEXT_COLOURS_EXTRA_LIGHT = 'hsl(274, 20%, 69%)';
export const TEXT_COLOURS_LIGHT = 'hsl(274, 20%, 69%)';
export const TEXT_COLOURS_DEFAULT = 'hsl(276, 25%, 52%)';
export const TEXT_COLOURS_DARK = 'hsl(278, 23%, 43%)';

export const BORDERS = {
    violet: `2px solid ${COLOURS_LIGHT.violet}`,
    blue: `2px solid ${COLOURS_LIGHT.blue}`,
    beige: `2px solid ${COLOURS_LIGHT.beige}`,
    grey: `2px solid ${COLOURS_LIGHT.grey}`,
    green: `2px solid ${COLOURS_LIGHT.green}`,
    red: `2px solid ${COLOURS_LIGHT.red}`,
    yellow: `2px solid ${COLOURS_LIGHT.yellow}`,
    pink: `2px solid ${COLOURS_LIGHT.pink}`,
};
// Typography
export const FONT_SIZE_DEFAULT = '16px';
export const FONT_SIZE_EXTRA_SMALL = '10px';
export const FONT_SIZE_SMALL = '14px';
export const FONT_SIZE_MEDIUM = '15px';
export const FONT_SIZE_LARGE = '34px';
export const FONT_SIZE_EXTRA_LARGE = '80px';

export const FONT_SIZE_DEFAULT_NUMBER = 16;
export const FONT_SIZE_EXTRA_SMALL_NUMBER = 10;
export const FONT_SIZE_SMALL_NUMBER = 14;
export const FONT_SIZE_MEDIUM_NUMBER = 15;
export const FONT_SIZE_LARGE_NUMBER = 34;
export const FONT_SIZE_EXTRA_LARGE_NUMBER = 80;

export const FONT_FAMILY = 'Nunito, sans-serif';
export const LINE_HEIGHT_HEADING = '1';
export const LINE_HEIGHT_NARROW_CONTENT = '1.5';
export const LINE_HEIGHT_REGULAR = '2';
export const LINE_HEIGHT_WIDE_CONTENT = '2.5';

export const FONT_WEIGHT_LIGHT = 400;
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_BOLD = 700;

// Spacing
export const PAD_EXTRA_SMALL = '4px';
export const PAD_SMALL = '8px';
export const PAD_MEDIUM = '12px';
export const PAD_LARGE = '16px';
export const PAD_EXTRA_LARGE = '24px';
export const PAD_EXTRA_EXTRA_LARGE = '72px';

export const PAD_EXTRA_SMALL_NUMBER = 4;
export const PAD_SMALL_NUMBER = 8;
export const PAD_MEDIUM_NUMBER = 12;
export const PAD_LARGE_NUMBER = 16;
export const PAD_EXTRA_LARGE_NUMBER = 24;
export const PAD_EXTRA_EXTRA_LARGE_NUMBER = 72;

// Miscellany
export const SHADOW = {
    slight: '0 1px 3px hsla(0, 0%, 0%, .2)',
    default: '0 5px 15px hsla(0, 0%, 0%, .2)',
};

export const BORDER_RADIUS = '12px';
export const BORDER_RADIUS_NUMBER = 12;
